import moment from 'moment';

import { Http } from '../../../support';

const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
const to = moment().format('YYYY-MM-DD');

export const initialState = {
  busy: false,
  data: [],
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
    from,
    to,
  },
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    state.app.receptores.excel = {
      ...state.app.receptores.excel,
      ...data,
    };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.app.receptores.excel.data = {
      ...state.app.receptores.excel.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.app.receptores.excel = {
      ...state.app.receptores.excel,
      busy: true,
      pagination: {
        ...state.app.receptores.excel.pagination,
        ...params,
      },
    };
  });

  try {
    const { pagination } = store.state.app.receptores.excel;

    const body = {
      ...pagination,
      ...params,
    };

    const response = await Http.get(`/api/excel_receptores`, { params: body });

    store.setState((state) => {
      state.app.receptores.excel = {
        ...state.app.receptores.excel,
        data: response.data,
        busy:false,
        pagination: {
          ...state.app.receptores.excel.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.receptores.excel.busy = false;
      state.app.receptores.excel.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.receptores.excel = {
      ...initialState,
    };
  });
};

const ReceptorExcelListStore = {
  state: () => initialState,
  actions: {
    change,
    setSelectedRows,
    paginate,
    reset,
  },
};

export default ReceptorExcelListStore;
